import { safeMemberDisplayName } from './displayName';

const SOURCE_TYPE_LABELS = {
  membership_change: 'Membership change',
  membership_checkout: 'Membership checkout',
  membership_initial_payment: 'Initial membership payment',
  membership_invoice: 'Membership renewal',
  membership_invoice_setup: 'Membership setup invoice',
  membership_setup_zero_charge: 'Membership setup',
  membership_zero_checkout: 'Membership checkout',
  learn_to_sail_checkout: 'Learn to Sail checkout',
  learn_to_sail_zero_checkout: 'Learn to Sail checkout',
};

function normalizeString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function formatDiscountRedemptionSource(sourceType = '') {
  const normalized = normalizeString(sourceType);
  return SOURCE_TYPE_LABELS[normalized] || '';
}

export function formatDiscountRedemptionLabel(entry = {}, { includeCode = true } = {}) {
  const code = includeCode ? normalizeString(entry?.code).toUpperCase() : '';
  const name = normalizeString(entry?.discountName);
  return code || name || 'Membership discount';
}

export function resolveDiscountRedemptionMemberName(entry = {}, userData = null) {
  const userId = normalizeString(entry?.userId);
  const memberNameSnapshot = normalizeString(entry?.memberNameSnapshot);
  if (memberNameSnapshot && memberNameSnapshot !== userId) return memberNameSnapshot;
  return safeMemberDisplayName(userData || {}, 'Member');
}
